module.exports = __webpack_public_path__ + "img/communicate.ec24219c.png";